import * as React from "react";
import Constants from "../../../../core/libraries/Constants";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { connect } from "react-redux";
import { RootState } from "../../../../store/store";
import { IUserProfile } from "../../../Auth/types";
import Helper from "../../../../core/libraries/Helper";
import _ from "lodash";
import RbLabel from "../../../../bosch-react/components/label/RbLabel";

interface Search_Refinement_ReportTypeProps {
  userProfile: IUserProfile | undefined;
  inputReportType: any;
  handleSearch: any;
}

class Search_Refinement_ReportType extends React.Component<
  Search_Refinement_ReportTypeProps,
  any
> {
  constructor(props: Search_Refinement_ReportTypeProps) {
    super(props);
    this.state = {
      reportTypes: Constants.DD_UPLOAD_TYPES_FOR_SEARCH,
      selectedReportType: "",
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    let selectedReportType =
      this.props.inputReportType !== "" ? this.props.inputReportType : "";
    
    this.setState({
      selectedReportType: selectedReportType,
    });
  }

  componentDidUpdate(prevProps: Search_Refinement_ReportTypeProps) {
    if (prevProps.inputReportType !== this.props.inputReportType) {
      this.setState({
        selectedReportType: this.props.inputReportType || "",
      });
    }
  }

  render() {
    let normalUserView = [
      { key: '', text: '--- All ---' },
      { key: 'LL', text: 'Lessons Learned' },
      { key: 'Thesis', text: 'Thesis' },
      { key: 'Paper', text: 'Paper' }
    ];
    let element = (
      <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <RbLabel hasPadding={true}>Report type</RbLabel>
            <Dropdown
              selectedKey={this.state.selectedReportType}
              options={this.props.userProfile?.permissions?.checkHasPermission([
                Constants.PERMISSIONS.RND_USER,
                Constants.PERMISSIONS.SUPER_ADMIN,
              ]) ? Constants.DD_UPLOAD_TYPES_FOR_SEARCH : normalUserView}
              onChange={this.handleSearch}
            />
          </div>
        </div>
      </div>
    );
    return element;
  }

  handleSearch(event: any, option: any) {
    this.props.handleSearch("reporttype", option.key);
    if (option.key === "") {
      this.setState({ selectedReportType: "" });
    } else {
      this.setState({ selectedReportType: option.key });
    }
  }


}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps)(Search_Refinement_ReportType);
